import React, { useEffect } from "react";
import "./Education.css";
import "../../global/main.css";
import { Element } from "react-scroll";
import "aos/dist/aos.css";
import Aos from "aos";
import hakale from "../../image/plan-04.png";

const Education = (props) => {
  const isMobile = props.isMobile || false;

  useEffect(() => {
    Aos.init({
      duration: 500,
      once: true,
      disable: isMobile ? false : "mobile",
    });
  }, [isMobile]);

  return (
    <Element name="Education">
      <section className="Education">
        <h2 className="heading" data-aos="fade-down" data-aos-duration="1000">
          هيكلية <span>العمل </span>
        </h2>
        <div className="education-body">
          <div
            className="education-image-container"
            data-aos="zoom-in"
            data-aos-duration="1500"
            data-aos-easing="ease-out-cubic"
          >
            <img
              src={hakale}
              alt="هيكلية مؤسسة اليسر للارتقاء العمراني"
              className="education-image"
            />
          </div>

          {/* Optional: Add interactive elements for mobile */}
          {isMobile && (
            <div className="mobile-instructions">
              <p>💡 يمكنك تكبير الصورة بالنقر عليها</p>
            </div>
          )}
        </div>
      </section>
    </Element>
  );
};

export default Education;
